import { createApiRef } from '@backstage/core-plugin-api';
import {
  GithubRunner,
  GithubRunnerDownloadInformation,
  GithubRunnerGroup,
  GithubRunnerRegistrationToken,
  GithubRunners,
  Tag,
} from './types';

export const githubRunnersApiRef = createApiRef<GithubRunnersApi>({
  id: 'plugin.githubrunners.service',
});

export type GithubRunnersApi = {
  getRunners: (runnerGroupId: string) => Promise<GithubRunners>;
  getRunner: (runnerId: string) => Promise<GithubRunner>;
  getRunnerGroups: () => Promise<GithubRunnerGroup[]>;
  getRunnerDownloads: () => Promise<GithubRunnerDownloadInformation[]>;
  getRegistrationToken: () => Promise<GithubRunnerRegistrationToken>;
  getRemovalToken: () => Promise<GithubRunnerRegistrationToken>;
  saveRunnerToGroup: (id: string, group: string) => Promise<boolean>;
  saveRunnerTags(id: string, tags: Tag[]): Promise<boolean>;
  deleteRunnerTags(id: string): Promise<boolean>;
  deleteRunnerTags(id: string): Promise<boolean>;
};
